import { Networker } from '@idp/networker';
import { offersService } from './Offers.service';
var loggingURI = '/msapi/reporting/v1/log/event';
import { EventActions } from '../services/AnalyticsEvents';
import ReportingGateway from './ReportingGateway';
export function logToSplunk(message) {
    var errors = [];
    errors.push(message.data);
    new Networker().post(loggingURI, { messages: errors }, offersService.fetchCRT())
        .then(function () { console.log('logged error to splunk'); })
        .catch(function (error) {
        console.error('could not send error to Splunk', error);
    });
}
export function logToSplunkwithExtraDetails(param, param2) {
    var vstatus = param.status ? param.status : '';
    var vURL = param2 ? param2.url : '';
    var apiName = param2 ? param2.apiName : '';
    var vmessage = (param2 && param2.message !== undefined) ? param2.message : '';
    var status2 = vstatus === '' ? '' : ', status=' + vstatus;
    // tslint:disable-next-line: no-any
    return param.text().then(function (res) {
        var text = 'Wireless_Buy_flow_UI';
        var splunkMessage = text + ", " + apiName + " " + status2 + ", " + vURL + " , " + res + " , " + vmessage;
        logToSplunk({ data: splunkMessage });
        var errObj = { ApiName: apiName, splunkMess: splunkMessage, status: vstatus, url: vURL };
        return (errObj);
    });
}
export function pageLoadforErrorModal() {
    var addData = {
        additionalData: {
            url: getPrefix() + 'cto/modal',
        },
        eventAction: EventActions.PAGE_LOAD,
        eventCode: 'Page_Load',
    };
    ReportingGateway.sendReportingEvent(addData);
}
function getPrefix() {
    return getWirelessType() === 'POSTPAID' ? '/buy/wireless/' : '/buy/wireless/prepaid/';
}
function getWirelessType() {
    var wirelessType = 'POSTPAID';
    var baseURL = this.stateManager.get('appShell', 'baseURL');
    if (baseURL && baseURL.url && (baseURL.url.indexOf('/prepaid') > -1)) {
        wirelessType = 'prepaid';
    }
    return wirelessType;
}
//# sourceMappingURL=logService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/services/logService.js
// module id = 345
// module chunks = 8